import React from 'react';
import { useHistory } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Box, Grid, Typography, Link } from '@material-ui/core';
import consts from './../../../main/consts';

const useStyles = makeStyles((theme) => ({
  listContent: {
    borderBottom: `1px solid ${grey[200]}`,
    borderTop: `1px solid ${grey[200]}`,
    maxHeight: '50vh',
    minWidth: 380,
    height: 130,
  },
  text: {
    height: '100%',
  },
  spacingBottom: {
    marginBottom: 10,
  },
  action: {
    padding: theme.spacing(3),
    paddingRight: theme.spacing(3),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
  },
}));

export default function AlertPopup(props) {
  const { open, numero, handleClose } = props;
  const history = useHistory();
  const classes = useStyles();

  const goToPedido = () => {
    history.push(`${consts.CONTEXT}/ready-to-go/${numero}`, { data: { page: 'ready-to-go' } });
    handleClose();
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogTitle>Atualização</DialogTitle>

        <DialogContent className={classes.listContent}>
          <Grid container direction="column" justify="space-between" alignItems="center" className={classes.text}>
            <Grid item>
              <Typography>Chamamos automaticamente um motoboy para o pedido <b>#{numero}</b></Typography>
            </Grid>
            <Grid item>
              <Link onClick={goToPedido}>Ver pedido</Link>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={classes.action}>
          <Box flexGrow={1} display="flex" p={0}>
            <Box flexGrow={1} >
              <Button onClick={handleClose} color="inherit">Fechar</Button>
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  )
}
